import { render, staticRenderFns } from "./DefaultValueWarnings.vue?vue&type=template&id=73bf5d04&scoped=true"
import script from "./DefaultValueWarnings.vue?vue&type=script&setup=true&lang=ts"
export * from "./DefaultValueWarnings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DefaultValueWarnings.vue?vue&type=style&index=0&id=73bf5d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf5d04",
  null
  
)

export default component.exports